// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Судові справи» (Legal Cases, ключ `lgc`, група `legal`). */
export const legalCasesManifest: IModuleManifest = {
  key: 'lgc',
  group: 'legal',
  slug: 'legal-cases',
  prefix: 'LGC',
  name: { en: 'Legal Cases', uk: 'Судові справи' },
  entities: [
    { key: 'lgc', slug: 'lgc', name: { en: 'Legal Cases', uk: 'Судові справи' }, main: true },
    { key: 'legal_case_party', slug: 'legal-case-party', name: { en: 'Legal Case Parties', uk: 'Сторони' }, main: false },
    { key: 'legal_case_hearing', slug: 'legal-case-hearing', name: { en: 'Legal Case Hearings', uk: 'Слухання' }, main: false },
    { key: 'legal_case_document', slug: 'legal-case-document', name: { en: 'Legal Case Documents', uk: 'Документи' }, main: false },
    { key: 'legal_case_deadline', slug: 'legal-case-deadline', name: { en: 'Legal Case Deadlines', uk: 'Строки' }, main: false },
  ],
  loadState: () => import('./state/legalCasesSlice').then((m) => m.legalCasesSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
